import { useEffect, useState } from 'react';
export function useAsync(asyncFunction, dependencies = []) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        let isMounted = true;
        const execute = async () => {
            setLoading(true);
            setError(null);
            try {
                const result = await asyncFunction();
                if (isMounted)
                    setData(result);
            }
            catch (error) {
                if (isMounted)
                    setError(error);
            }
            finally {
                if (isMounted)
                    setLoading(false);
            }
        };
        execute();
        return () => {
            isMounted = false;
        };
    }, dependencies);
    return { data, loading, error };
}
//# sourceMappingURL=use-async.js.map